/**
 * Kravet och nivån i ett 403 från POST /accountactions?target=control, eller null när
 * nekandet inte gäller nivån.
 *
 * apply svarar { reason: "level", required, current } när inloggningen inte räcker för
 * stiftelsen och { reason: "role" } när kontot saknar Control och Finance där, samma form som
 * apply-application (apply-system 0023). Ett svar utan reason men med required kommer från en
 * apply som ännu inte har reason och läses som nivå.
 */
export function parseRefusal(body) {
  let refusal;
  try {
    refusal = JSON.parse(body || '');
  } catch {
    return null;
  }
  if (!refusal || !refusal.required) return null;
  if (refusal.reason && refusal.reason !== 'level') return null;
  return { required: refusal.required, current: refusal.current || '' };
}
